import { UserInfoDto, UserSiteInfoDto } from '../api';
import { User, UserSite } from './auth.models';

export const userFullName = (user: User) => `${user.firstName} ${user.lastName.toUpperCase()}`;

export const userInitials = (user: User) => `${user.firstName[0].toUpperCase()} ${user.lastName[0].toUpperCase()}`;

export const map_UserInfoDto_User = (dto: UserInfoDto): User => ({
  ...dto,
  sites: dto.sites.map((siteDto) => map_SiteInfoDto_SiteInfo(siteDto)),
});

export const map_SiteInfoDto_SiteInfo = (dto: UserSiteInfoDto): UserSite => ({
  ...dto,
  isCashRegisterUsable: dto.hasCashRegister && !dto.registrationWithoutCashRegister,
});
